import React from 'react';
import {
  Box,
  Container,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  TextField,
  Button,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Page from 'src/components/Page';
import Results from './Results';
import Toolbar from './Toolbar';
import getActiveCustomers from '../../../requests/getActiveCustomers';

const useStyles = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
});

class CustomerListView extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      customers: [],
      roles: [],
      newCustomer: {
        first_name: '',
        last_name: '',
        company: '',
        gst_no: '',
        email_id: '',
        phone_no: '',
        address_line_1: '',
        address_line_2: '',
        city: '',
        state: 'Karnataka',
        country: 'India',
        zipcode: '56',
        status: 'Active'
      },
      addCustomerOpen: false
    };
  }

  componentDidMount = async () => {
    let response = await getActiveCustomers();
    const { keycloak } = this.props;
    response = _.map(response, (res, key) => { return { id: key, ...res }; });
    response = _.orderBy(response, ['date_added'], ['desc']);
    this.setState({ customers: response, roles: _.get(keycloak, ['realmAccess', 'roles']) });
  }

  addCustomerModal = () => {
    const { addCustomerOpen } = this.state;
    this.setState({ addCustomerOpen: !addCustomerOpen });
  }

  render() {
    const { classes } = this.props;
    const {
      customers,
      roles,
      newCustomer,
      addCustomerOpen
    } = this.state;

    return (
      <Page
        className={classes.root}
        title="Customers"
      >
        <Container maxWidth={false}>
          <Toolbar roles={roles} addCustomerModal={this.addCustomerModal} />
          {addCustomerOpen
            && (
            <Box mt={6}>
              <Card>
                <CardHeader title="Add New Customer" action={<Button variant="contained" color="secondary" onClick={() => this.addCustomerModal()}>Cancel</Button>} />
                <CardContent>
                  <form noValidate autoComplete="off">
                    {JSON.stringify(newCustomer)}
                    <div>
                      <TextField required id="standard-required" label="Required" defaultValue="Hello World" />
                      <TextField disabled id="standard-disabled" label="Disabled" defaultValue="Hello World" />
                      <TextField
                        id="standard-password-input"
                        label="Password"
                        type="password"
                        autoComplete="current-password"
                      />
                      <TextField
                        id="standard-read-only-input"
                        label="Read Only"
                        defaultValue="Hello World"
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                      <TextField
                        id="standard-number"
                        label="Number"
                        type="number"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      <TextField id="standard-search" label="Search field" type="search" />
                      <TextField
                        id="standard-helperText"
                        label="Helper text"
                        defaultValue="Default Value"
                        helperText="Some important text"
                      />
                    </div>
                    <div>
                      <TextField
                        required
                        id="filled-required"
                        label="Required"
                        defaultValue="Hello World"
                        variant="filled"
                      />
                      <TextField
                        disabled
                        id="filled-disabled"
                        label="Disabled"
                        defaultValue="Hello World"
                        variant="filled"
                      />
                      <TextField
                        id="filled-password-input"
                        label="Password"
                        type="password"
                        autoComplete="current-password"
                        variant="filled"
                      />
                      <TextField
                        id="filled-read-only-input"
                        label="Read Only"
                        defaultValue="Hello World"
                        InputProps={{
                          readOnly: true,
                        }}
                        variant="filled"
                      />
                      <TextField
                        id="filled-number"
                        label="Number"
                        type="number"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        variant="filled"
                      />
                      <TextField id="filled-search" label="Search field" type="search" variant="filled" />
                      <TextField
                        id="filled-helperText"
                        label="Helper text"
                        defaultValue="Default Value"
                        helperText="Some important text"
                        variant="filled"
                      />
                    </div>
                    <div>
                      <TextField
                        required
                        id="outlined-required"
                        label="Required"
                        defaultValue="Hello World"
                        variant="outlined"
                      />
                      <TextField
                        disabled
                        id="outlined-disabled"
                        label="Disabled"
                        defaultValue="Hello World"
                        variant="outlined"
                      />
                      <TextField
                        id="outlined-password-input"
                        label="Password"
                        type="password"
                        autoComplete="current-password"
                        variant="outlined"
                      />
                      <TextField
                        id="outlined-read-only-input"
                        label="Read Only"
                        defaultValue="Hello World"
                        InputProps={{
                          readOnly: true,
                        }}
                        variant="outlined"
                      />
                      <TextField
                        id="outlined-number"
                        label="Number"
                        type="number"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        variant="outlined"
                      />
                      <TextField id="outlined-search" label="Search field" type="search" variant="outlined" />
                      <TextField
                        id="outlined-helperText"
                        label="Helper text"
                        defaultValue="Default Value"
                        helperText="Some important text"
                        variant="outlined"
                      />
                    </div>
                  </form>
                </CardContent>
                <CardActions>
                  <div>Footer Buttons</div>
                </CardActions>
              </Card>
            </Box>
            )}
          <Box mt={3}>
            <Results customers={customers} roles={roles} />
          </Box>
        </Container>
      </Page>
    );
  }
}

CustomerListView.propTypes = {
  classes: PropTypes.any,
  keycloak: PropTypes.any,
};

export default withStyles(useStyles)(CustomerListView);
